import React from "react";
import {Controller} from 'react-hook-form';

export default function ({label, name, control, errorMessage, required = false}) {
  return (
    <>
      <Controller
        name={name}
        control={control}
        defaultValue=''
        render={({field: {onChange, value}}) => (
          <div className={`fv-row mb-10`}>
            <label className="form-label fs-6 fw-bolder text-dark">
              {label}{required && (<span className="text-danger fw-bolder fs-6"> *</span>)}
            </label>
            <input
              className='form-control form-control-lg form-control-solid'
              type='datetime-local'
              required={required}
              value={value || ''}
              onChange={e => onChange(e.target.value)}
            />

            {errorMessage && (
              <div className="fv-plugins-message-container invalid-feedback">
                <div>{errorMessage}</div>
              </div>
            )}
          </div>
        )}
      />
    </>
  );
}